import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-feature',
	templateUrl:'./FeaturePluginCompPage.html',
	styles: [],
	styleUrls:['./FeaturePluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class FeaturePluginCompPage
{
	mdContent_911 = `\`\`\`java
import com.jwebmp.core.base.Feature;
\`\`\``;
	mdContent_912 = `\`\`\`java
Feature(String name)
\`\`\``;
	mdContent_913 = `\`\`\`java
Feature(String name, IComponentHierarchyBase component)
\`\`\``;
	mdContent_914 = `\`\`\`java
public class FadeInFeature extends Feature&lt;FadeInFeature&gt; {
    public FadeInFeature(IComponentHierarchyBase component) {
        super("FadeIn", component);
    }
    @Override
    protected void assignFunctionsToComponent() {
        addQuery("$('#" + getComponent().getID() + "').fadeIn();");
    }
}
\`\`\``;
}
